var React = require('react');

function CashFlow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.431 13.6133H9.07788V21.7872H25.431V13.6133Z","fill":"#4F555F","key":0}),React.createElement("path",{"d":"M20.9171 8.21484V13.6083H9.08295V16.394H4.56396V8.21484H20.9171Z","fill":"#C7CED4","key":1}),React.createElement("path",{"d":"M25.4362 13.6094V21.7886H9.08301V16.3951H20.9172V13.6094H25.4362Z","fill":"#8C95A3","key":2})]);
}

CashFlow.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = CashFlow;

CashFlow.default = CashFlow;
